import { Vector2 } from "three";
import { ClassFlag } from "../../library-js/dom-tools/ClassFlag";
import { DOMHitTest } from "../../library-js/dom-tools/DOMHitTest";
import { ElementType } from "../../library-js/dom-tools/ElementType";
import { Events, OnDrag } from "../../library-js/dom-tools/EventListeners";
import { EventSlot } from "../../library-js/events/EventSlot";
import { Property } from "../../library-js/events/Property";
import { MathX } from "../../library-js/math/MathX";


export class VerticalSliderElement extends HTMLElement
{
  _value:VerticalSliderValue;
}

export class VerticalSliderValue
{
  _element:VerticalSliderElement
  _button:HTMLElement;
  _offset:Vector2;
  _cachedValue:number = 0;
  _ownWidth:number;
  readonly value = new Property<number>( 0);

  constructor( e:VerticalSliderElement )
  {
    this._element = e;
    this._button = VerticalSlider.button.query( e ) as HTMLElement;

    this.assignListeners();    
  }

  
  assignListeners()
  {

    OnDrag.add( this._button, 
      ( e )=>
      {
        let position = DOMHitTest.getRelativePointerPosition( e, this._element );

        if ( Events.isStart( e ) )
        {
          this._offset = position.clone();     
          this._cachedValue = this.value.value;     
          ClassFlag.active.set( this._element );
          ClassFlag.active.set( this._button );
          
          VerticalSlider.lock()
          this._ownWidth = this._button.getBoundingClientRect().width;

          Events.silent( e );
          return;
        }
        else if ( Events.isEnd( e ) )
        {
          VerticalSlider.free();

          ClassFlag.active.removeFrom( this._element );
          ClassFlag.active.removeFrom( this._button );
          return;
        } 

        Events.silent( e );

        let movement = position.clone().sub( this._offset );
        let bounds = this._element.getBoundingClientRect();
        let moveRange = bounds.width - this._ownWidth;

        // console.log( "Move Range:", this._element, bounds.width, this._ownWidth, moveRange );
        let change = movement.x / moveRange;
        this.value.value = MathX.clamp01( this._cachedValue + change );
      } 
    );

    this.value.addListener(
      ()=>
      {
        if ( ! this._ownWidth )
        {
          this._ownWidth = this._button.getBoundingClientRect().width;
        }

        let bounds = this._element.getBoundingClientRect();
        let left = MathX.clamp( this.value.value * bounds.width, 0, bounds.width - this._ownWidth );

        // console.log( left, this.value.value, bounds.width, this._ownWidth );
        this._button.style.left = left + "px";
      }
    );

    let observer = new ResizeObserver(
      ( entries )=>
      {
        this._ownWidth = null;
        this.value.forceDispatch();
      }
    );

    observer.observe( this._element );


  }
}

export class VerticalSlider
{
  static type = new ElementType( "vertical--slider" );
  static button = new ElementType( "slider--button" );

  static lock:()=>void;
  static free:()=>void;

  static applyOnDocument( lockCursor:()=>void, freeCursor:()=>void)
  {
    this.lock = lockCursor;
    this.free = freeCursor;

    VerticalSlider.type.forAllInDoc( e => VerticalSlider.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let vse = e as VerticalSliderElement;
    vse._value = new VerticalSliderValue( vse );



  } 
}